<template>
  <FormContainer class="verify-email__setup-password-form__form-container">
    <div class="setup-password-form__text-block">
      <h2 class="setup-password-form__title">Помилка</h2>
      <p class="setup-password-form__description">{{ getEmailVerificationError }}</p>
    </div>
  </FormContainer>
</template>

<script>
import { mapGetters } from 'vuex';
import { FormContainer } from '@/shared/ui/account';

export default {
  components: { FormContainer },
  computed: {
    ...mapGetters('registerModule', ['getEmailVerificationError']),
  }
};
</script>

<style lang="scss" scoped>
.verify-email__setup-password-form {
  &__form-container {
    margin: 170px auto 0;
    width: 600px;

    @media (max-width: 630px) {
      margin: 50px 16px 0;
      width: auto;
    }
  }
}

.setup-password-form {
  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 36px;
    font-weight: 400;
    color: #0C1421;
    text-align: center;
    margin-bottom: 16px;

    @media (max-width: 630px) {
      font-size: 24px;
    }
  }

  &__description {
    font-size: 18px;
    font-weight: 400;
    color: #313957;
    text-align: center;

    @media (max-width: 630px) {
      font-size: 14px;
    }
  }
}
</style>
